module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/debitcard/debitcard.component.css
// module id = ./src/app/sendMoney/debitcard/debitcard.component.css
// module chunks = main